import { render, staticRenderFns } from "./EPaperManageView2.vue?vue&type=template&id=73725316&scoped=true&"
import script from "./EPaperManageView2.vue?vue&type=script&lang=js&"
export * from "./EPaperManageView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73725316",
  null
  
)

export default component.exports